import { useQuery } from "@apollo/client";
import GetGatheringForPublicPreviewDocument from "src/api/graphql/__generated__/documents/GetGatheringForPublicPreviewDocument";

const useGatheringPublicPreviewInfo = (
	gatheringId: string,
	{
		fetchPolicy = "cache-first",
	}: {
		fetchPolicy?: "cache-and-network" | "cache-first";
	} = {},
) => {
	const { data, refetch, loading } = useQuery(GetGatheringForPublicPreviewDocument, {
		variables: {
			input: {
				gatheringId,
			},
			previewPhotosInput: {
				limit: 32,
			},
		},
		fetchPolicy,
	});

	return {
		gathering: data?.getGathering,
		refetch,
		loading,
	};
};

export type GatheringPublicPreviewGatheringInfo = ReturnType<
	typeof useGatheringPublicPreviewInfo
>["gathering"];

export default useGatheringPublicPreviewInfo;
